export function withVariables(editor) {
  const { isInline, isVoid } = editor;

  editor.isInline = element => (element.type === 'variable' ? true : isInline(element));

  editor.isVoid = element => (element.type === 'variable' ? true : isVoid(element));

  return editor;
}
